import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class CommonService {
  constructor() { 
 
  }
  IsMobile() {
    let userAgent = navigator.userAgent,Agents = ["Android", "iPhone","SymbianOS", "Windows Phone","iPad", "iPod"];
    return Agents.some((i)=>{
        return userAgent.includes(i)
    })
  }
  makeHttpOptions() {
    const headerEntries:any = {};
    let accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      // Inject access token to HTTP request header
      headerEntries['Authorization'] = `Bearer ${accessToken}`;
    }
    return {
      headers: new HttpHeaders(headerEntries),
    };
  }


}
